import React from "react";
import AppDatePicker from "../DatePicker/AppDatePicker";

/* ═══════════════════════════════════════════════════════════════════════════
   PremiumDatePicker — BACK-COMPAT ADAPTER.

   This used to be a second, hand-rolled calendar with its own look. To keep a
   SINGLE date-picker implementation and one consistent brand style across the
   whole app, it now delegates to the shared AppDatePicker. The public props are
   unchanged, so every existing consumer keeps working without edits — they just
   render the one shared picker now.

   Prefer importing AppDatePicker directly in new code.
   ═══════════════════════════════════════════════════════════════════════════ */

interface Props {
  value: string; // "YYYY-MM-DD" or ""
  onChange: (value: string) => void;
  label?: string;
  error?: boolean;
  size?: "small" | "medium";
  sx?: object;
  minDate?: string; // "YYYY-MM-DD"
  placeholder?: string;
}

const PremiumDatePicker: React.FC<Props> = ({
  value,
  onChange,
  label = "Date",
  error = false,
  size = "small",
  sx,
  minDate,
  placeholder = "Select date",
}) => (
  <AppDatePicker
    value={value}
    onChange={onChange}
    label={label}
    error={error}
    size={size}
    sx={sx}
    minDate={minDate}
    placeholder={placeholder}
  />
);

export default PremiumDatePicker;
